"use strict";
exports.__esModule = true;
exports.asyncPipe = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function (x) { return fns.reduce(function (m, f) { return m.then(f); }, x); };
};
//# sourceMappingURL=utils.js.map